import { useAppState } from "src/state";
import { Icons } from "src/components/ui/Icons";
import { ViewSchemaRenderer } from "src/components/ui/ViewSchemaRenderer";
import { SuperAdminBookingViewSchema } from "src/components/superadmin/bookings/SuperAdminBookingViewSchema";

export function SuperAdminBookingView() {

    const { currentItem } = useAppState().bookings;

    if (!currentItem) return null;

    return (
        <ViewSchemaRenderer
            schema={SuperAdminBookingViewSchema}
            data={currentItem}
            title="Booking Overview"
            icon={Icons.booking}
        />
    );
}
